import { isTradingViewBroker } from "./tradingViewBroker";
import { isTradingViewPaperBroker } from "./tradingViewPaperBroker";

/** Short lane label when two TradingView logos would otherwise look identical. */
export function resolveTradingViewLaneBadge(
  brokerName: string | null | undefined
): "Backtest" | "Paper" | null {
  if (isTradingViewPaperBroker(brokerName)) return "Paper";
  if (isTradingViewBroker(brokerName)) return "Backtest";
  return null;
}
